import { Routes } from '@angular/router';
import { AUTH_REDIRECT_ROUTE } from '@shared/constants/fields.constants';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const SMART_FORECASTING_ROUTES: Routes = [
  {
    path: 'smart-forecasting/forecast-trends',
    loadComponent: () =>
      import('../forecast-trends/forecast-trends.component').then((c) => c.ForecastTrendsComponent),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_VIEW_SARIMA_FORECAST'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
      breadcrumb: 'Forecast Trends',
    },
  },
  {
    path: 'smart-forecasting/historical-predictions',
    loadComponent: () =>
      import('../historical-predictions/historical-predictions.component').then((c) => c.HistoricalPredictionsComponent),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_VIEW_SARIMA_FORECAST'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
      breadcrumb: 'Historical Predictions',
    },
  },
  {
    path: 'smart-forecasting/historical-imports',
    loadComponent: () =>
      import('../historical-imports/historical-imports.component').then((c) => c.HistoricalImportsComponent),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_VIEW_SARIMA_FORECAST'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
      breadcrumb: 'Import Data',
    },
  },
  {
    path: 'smart-forecasting/model-training-operations',
    loadComponent: () =>
      import('../model-training-operations/model-training-operations.component').then((c) => c.ModelTrainingOperationsComponent),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_VIEW_SARIMA_FORECAST'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
      breadcrumb: 'Model Training',
    },
  },
  {
    path: 'smart-forecasting/trained-models',
    loadComponent: () =>
      import('../trained-models/trained-models.component').then((c) => c.TrainedModelsComponent),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_VIEW_SARIMA_FORECAST'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
      breadcrumb: 'Training Models',
    },
  },
  {
    path: 'smart-forecasting/sarima-model-runs',
    loadComponent: () =>
      import('../sarima-model-runs/sarima-model-runs.component').then((c) => c.SarimaModelRunsComponent),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_VIEW_SARIMA_FORECAST'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
      breadcrumb: 'SARIMA Model Runs',
    },
  },
];
